import FilterRegions from './FilterRegions';

export default FilterRegions;
